define('taoQtiItem/qtiCreator/widgets/choices/gapText/states/states',[
    'taoQtiItem/qtiCreator/widgets/states/factory',
    'taoQtiItem/qtiCreator/widgets/choices/states/states',
    'taoQtiItem/qtiCreator/widgets/choices/gapText/states/Choice'
], function(factory, states){
    return factory.createBundle(states, arguments);
});
